export class EventEmmiter {
  evMap: { [key: string]: ((...prams: any) => void)[] } = {}

  on(event: string, callback: (...params: any) => void) {
    if (!this.evMap[event]) {
      this.evMap[event] = []
    }
    this.evMap[event].push(callback)
    return () => this.off(event, callback)
  }

  off(event: string, callback: (...params: any) => void) {
    if (this.evMap[event]) {
      this.evMap[event] = this.evMap[event].filter((cb) => cb !== callback)
    }
  }

  /**
   * событие 'all' вызывается для всех событий
   */
  emit(event: string, ...params: any) {
    if (this.evMap[event]) {
      this.evMap[event].forEach((cb) => cb(...params))
    }
    if (this.evMap['all']) {
      this.evMap['all'].forEach((cb) => cb(event, params))
    }
  }
}
